<p-toast position="top-right"></p-toast>

<div class="root-body"
     [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
    'root-body-horizontal': configService.config.menuMode === 'horizontal'}">
    <div class="flex flex-row mb-3" style="align-items: center">
        <div class="head-title">
            Quest Reports <span *ngIf="blockedPanel"><p-progressSpinner [style]="{width: '20px', height: '25px'}" styleClass="custom-spinner" strokeWidth="5" fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner></span>
        </div>

        <div class="mr-2 ml-auto">
            <p-dropdown [options]="challengeQuestTypeList" placeholder="Select Quest Type"
                        optionLabel="name" optionValue="id" [(ngModel)]="filterQuests.challengeQuestType"
                        (ngModelChange)="handleFilterChange($event)"></p-dropdown>
        </div>

        <div class="mr-2">
            <p-calendar [appendTo]="'body'"
                        [inputStyle]="{'height': '45px', 'background-color': 'white', 'color': 'black'}"
                        selectionMode="range" [readonlyInput]="true" [showIcon]="true" [(ngModel)]="selectedDateRange"
                        (ngModelChange)="handleFilterChange($event)" />
        </div>
        <div class="report-customer-header__separator"></div>
        <div class="mr-2">
            <button style="height: 35px;" class="bluedark-btn" pButton label="Export Data" [loading]="loadingExportData" (click)="exportQuestReport(exportFileTypeEnum.CSV)"></button>
        </div>
    </div>

    <ng-container>
        <div class="card">
            <p-scrollPanel [style]="{width:'100%', height: 'calc(72vh)'}"
                           [styleClass]="'app-scrollpanel'">
                <p-table [value]="quests" [tableStyle]="{'min-width': '50rem'}">
                    <ng-template pTemplate="header">
                        <tr>
                            <th *ngFor="let col of colums"
                                [style.width]="col.width">
                                {{col.header}}
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-quest>
                        <tr>
                            <td *ngFor="let col of colums">
                                {{quest[col.field]}}
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </p-scrollPanel>
        </div>
    </ng-container>

</div>